import { createAsyncThunk } from '@reduxjs/toolkit';

import citcTranslations from 'constants/translations_citc.json';
import translations from 'constants/translations.json';
import { Locales } from 'constants/enums';

export const getTranslations = createAsyncThunk('intl/getTranslations', async () => {
  // TODO: once we have everything we need on the translations files
  // re-implement this as a either a get to the Nest stack
  // or loading it from as sub-repo that would contain this and the measurement class data
  const strings: any = { ...citcTranslations, ...translations };
  const locales = Object.values(Locales);
  const allTranslations: any = {};
  locales.forEach((locale) => {
    allTranslations[locale] = {};
  });
  Object.keys(strings).forEach((key) => {
    locales.forEach((locale) => {
      if (strings[key][locale]) {
        allTranslations[locale][key] = strings[key][locale] as string;
      } else if (strings[key]['en']) {
        // default to english if not set
        allTranslations[locale][key] = strings[key]['en'] as string;
      }
    });
  });
  return allTranslations as ITranslations;
});
